<a
  class="subnav-item flex items-center gap-2 w-full cursor-pointer min-h-9 py-[6px] mb-1"
  [class.parent]="variant() === 'parent'"
  [class.child]="variant() === 'child'"
  [class.child-of-child]="variant() === 'child-of-child'"
  [routerLink]="link()"
  [routerLinkActive]="['active']">
  @if (icon() && variant() === 'parent') {
    <ui-icon class="mr-1 text-gray-400" [icon]="icon()!" [size]="24" />
  }

  @if (variant() === 'child' || variant() === 'child-of-child') {
    <div class="spacer" [class.mr-7]="variant() === 'child'" [class.mr-12]="variant() === 'child-of-child'"></div>
  }

  <span class="subnav-value flex-1 truncate text-gray-700 transition-colors hover:text-primary-600">{{ value() }}</span>

  @if (isNew() && badgeText() === null) {
    <ui-badge variant="secondary" size="sm" value="New" />
  }

  @if (badgeText() !== null) {
    <ui-badge variant="secondary" size="sm" [value]="badgeText()!" />
  }
</a>
